import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import PageMeta from "@/components/base/PageMeta";

export default function NotFound() {
  return (
    <SiteLayout>
      <PageMeta
        title="页面不存在 - 高校吃瓜网"
        description="你访问的页面可能已经调整或不存在，回到首页看看今天的热搜榜，或者直接进入讨论区浏览各校热门帖子。"
        keywords="高校吃瓜,页面不存在,高校吃瓜论坛"
        path="/"
      />
      <div className="mx-auto flex w-full flex-col items-center px-4 py-24 text-center md:px-8 md:py-32">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-700">
          <i className="ri-emotion-sad-line text-3xl"></i>
        </span>
        <p className="mt-6 font-heading text-5xl font-black tracking-tight text-foreground-950 md:text-6xl">
          404
        </p>
        <h1 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
          这个页面没有瓜
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600 md:text-[15px]">
          你访问的地址可能已经调整或不存在。回到首页看看今天的热搜榜，或者直接进讨论区找找同校的现场。
        </p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            <i className="ri-home-4-line text-base"></i>
            返回首页
          </Link>
          <Link
            to="/topics"
            className="inline-flex items-center gap-2 rounded-md border border-foreground-300 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700 whitespace-nowrap"
          >
            <i className="ri-compass-3-line text-base"></i>
            去讨论区
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}